import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Tab } from 'react-bootstrap'
import { Tabs } from '../../components/Tabs/Tabs'
import { createSearchParams, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { PlanTab } from './PlanTab'
import { BillingTab } from './BillingTab'
import { useGetBillingCustomerQuery } from '../../store/plan/plan'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useDocumentTitle } from '../../common/useDocumentTitle'

export const Plan: React.FC = () => {
  useDocumentTitle('Plan')
  const accountId = useAppSelector(selectAccountId)
  const { activeTab = 'plan' } = useParams()
  const [selectedTab, setSelectedTab] = useState(activeTab)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { data: customer } = useGetBillingCustomerQuery({ accountId })

  const hideBillingInfo = !customer?.data.subscription || !!customer.data.enterpriseSubscription?.enterpriseBillingConfig.package.hideBillingInfo

  useEffect(() => {
    const period = searchParams.get('period')
    const checkoutSuccess = searchParams.get('checkoutSuccess')
    navigate(
      {
        pathname: `/account/plan/${selectedTab}`,
        search: createSearchParams({ ...(period && { period }), ...(checkoutSuccess && { checkoutSuccess }) }).toString(),
      },
      { replace: true },
    )
  }, [navigate, searchParams, selectedTab])

  const changeTab = (key: string | null) => {
    if (key) {
      setSelectedTab(key)
    }
  }

  useEffect(() => {
    changeTab(activeTab)
  }, [activeTab])
  return (
    <Container>
      <Row className='mb-9'>
        <Col>
          <h3>Plan</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs onSelect={changeTab} defaultActiveKey={selectedTab} id='plan-tabs' className='d-flex gap-2r mb-3'>
            <Tab className='mt-5' eventKey='plan' title='Plan'>
              <PlanTab />
            </Tab>
            {!hideBillingInfo ? (
              <Tab className='mt-5' eventKey='billing' title='Billing'>
                <BillingTab />
              </Tab>
            ) : null}
          </Tabs>
        </Col>
      </Row>
    </Container>
  )
}
